import { chartTableFlatTransformer } from '../chartTableFlatTransformer';
import { getPercentage } from './tableUtils';

const tableWithTotal = (data) => {
  const opened_jobs_total = data?.reduce(
    (acc, curr) => acc + curr?.opened_jobs,
    0
  );
  const closed_jobs_total = data?.reduce(
    (acc, curr) => acc + curr?.closed_jobs,
    0
  );
  const closed_without_hires_total = data?.reduce(
    (acc, curr) => acc + curr?.closed_without_hires,
    0
  );
  const target_breached_jobs_total = data?.reduce(
    (acc, curr) => acc + curr?.target_breached_jobs,
    0
  );

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      return {
        ...datum,

        opened_jobs_total,
        opened_jobs_per: getPercentage(datum?.opened_jobs, opened_jobs_total),

        closed_jobs_total,
        closed_jobs_per: getPercentage(datum?.closed_jobs, closed_jobs_total),

        target_breached_jobs_total,
        target_breached_jobs_per: getPercentage(
          datum?.target_breached_jobs,
          target_breached_jobs_total
        ),

        closed_without_hires_total,
        closed_without_hires_per: getPercentage(
          datum?.closed_without_hires,
          closed_without_hires_total
        ),

        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

export const jobsTableTransformer = ({ response, args }) => {
  // Safely extract properties from response
  const { chart = [], headers, lookups, table = [] } = response || {};

  // using the new g1_l2 if present or fallback to g1
  // using the g2_l2 if present or fallback to g2
  const { dt, g1_l2 = [], g1, g2, g2_l2 = [] } = lookups || {}; // Lookup mappings for data transformation

  const latestG1 = g1_l2?.length ? g1_l2 : g1;
  // const latestG2 = g2_l2?.length ? g2_l2 : g2;

  const data =
    g1_l2?.length || g1?.length || g2_l2?.length || g2?.length ? table : chart;
  const headerKey = latestG1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};
  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1Key: group_by_1?.id || group_by_1,
    g2Key: group_by_2?.id || group_by_2,
    g1_l2,
    g2_l2,
  });

  const tableData = tableWithTotal(transformedData);

  return tableData;
};
